export default class SeminarCancel {

    // constructor
    constructor(selector) {
        this.button = document.querySelector('[data-tncp-action-seminar-cancel]')
        if(this.button){

            this.buttonText = this.button.innerText
            this.buttonSendText = this.button.getAttribute('data-tncp-action-seminar-cancel-sendingText')
            this.errorText = this.button.getAttribute('data-tncp-action-seminar-cancel-errorText')
            this.xhrPath = this.button.getAttribute('data-tncp-action-seminar-cancel-xhrpath')

            this.reason = document.querySelector('[data-tncp-seminar-cancelation-reason]')

            this.plugin =  $.find(selector);

            //Initialize popup element
            $(this.plugin).magnificPopup({
                items: {
                    src: '#popup',
                    type: 'inline'
                }
            });
            this.addEvents()
        }
    };

    initializePopup(){

        return this
    }

    closePopup(){

        $.magnificPopup.close()

        return this
    }

    requestCancelation(){
        this.animate(true);

        axios.post(
            this.xhrPath,
            'tx_tuevnordcustomerportal_api%5Breason%5D=' + this.reason.value,
            {
                headers : {'Content-Type': 'application/x-www-form-urlencoded'}
            }
        )
            .then((response) => {
                this.closePopup().animate(false)
            })
            .catch((error) => {
                this.animate(false).closePopup().showErrorinfo()
            });

        return this
    }

    showErrorinfo(){

        $.magnificPopup.open({
            items: {
                src: "<div class='c-popup'><div class='c-text'>" + this.errorText + "</div></div>",
                type: 'inline'
            }
        });

    }

    animate(yes){
        if(yes) {
            this.button.innerText = this.buttonSendText
            this.button.classList.add('u-skeleton__item', 'u-skeleton__item--full')
        }
        else {
            this.button.classList.remove('u-skeleton__item','u-skeleton__item--full')
            this.button.innerText = this.buttonText
        }
        return this
    }

    addEvents(){
        this.button.addEventListener('click',(event) => this.animate().requestCancelation())

    }
}